export default "__VITE_PUBLIC_ASSET__5f294849__"